var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSidebarClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.49992 5.49992C5.89045 5.1094 6.52361 5.1094 6.91414 5.49992L11.9999 10.5857L17.0857 5.49997C17.4762 5.10945 18.1094 5.10945 18.4999 5.49997C18.8905 5.8905 18.8905 6.52366 18.4999 6.91419L13.4141 11.9999L18.4999 17.0858C18.8904 17.4763 18.8904 18.1095 18.4999 18.5C18.1094 18.8905 17.4762 18.8905 17.0857 18.5L11.9999 13.4142L6.91414 18.5C6.52362 18.8905 5.89045 18.8905 5.49993 18.5C5.1094 18.1094 5.1094 17.4763 5.49993 17.0858L10.5857 11.9999L5.49992 6.91414C5.1094 6.52361 5.1094 5.89045 5.49992 5.49992Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSidebarClose);
export default __webpack_public_path__ + "static/media/ic_sidebar-close.7a4b9dc7e6eb86beddfa51e0a2148619.svg";
export { ForwardRef as ReactComponent };